// extracted by mini-css-extract-plugin
module.exports = {"root":"NavItem-module--root--2jZJP","active":"NavItem-module--active--3zTzF"};